module.exports = __webpack_public_path__ + "img/videowiki-cast.6633cc26.svg";